<template>
    <div>
      <ViewTemplate :table-props="mappingColumns" :project-param-id="projectParamId" :mapper-param-id="mapperParamId"/>
    </div>
</template>

<script>

import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import TabContentView from "./TabContentView.vue";
import ViewTemplate from "@/components/ViewTemplate.vue";
export default {
    name: pageViews.MAPPING_JOBS_VIEW,
    methods: {
        setValuesToStore(type) {
            Store.commit("setType", type);
        }
    },
    mounted() {
        this.setValuesToStore(type.MAPPER_MAPPING_JOBS);
        console.log("Type passed to ViewTemplate:", type.MAPPER_MAPPING_JOBS); // Debugging log
        console.log("Mapping Columns:", this.mappingColumns); // Debugging log
    },
    components: {
      TabContentView,
      ViewTemplate
    },
    data() {
      return {
        uploadConfigs: {
          action: "generator",
          actionLabel: "Generator",
          title: "Mapper Config Generator",
          type: type.MAPPER_MAPPING_JOBS,
          accept: ".zip",
        },
        mappingColumns: {
          type: type.MAPPER_MAPPING_JOBS, // Ensure this matches the backend expectation
          isMultiSelectionAllowed: true,
          defaultSortOrder: { name: "desc", label: "Descending" },
          defaultSortColumn: { name: "requestedDate", label: "Requested Date" },
          configs: [
            { name: "requestedDate", label: "Requested Date", order: 1, defaultSelected: true, type: "date", textAlign: "center", headerTextAlign: "center" },
            { name: "jobId", label: "Job Id", order: 2, isSortable: true, defaultSelected: true, textAlign: "center", headerTextAlign: "center" },
            { name: "createdBy", label: "Created By", order: 3, defaultSelected: true, textAlign: "left", headerTextAlign: "center" },
            { name: "status", label: "Status", order: 4, isSortable: true, defaultSelected: true, textAlign: "center", headerTextAlign: "center" },
            { name: "completedDate", label: "Completed Date", order: 5, isSortable: true, type: "date", defaultSelected: true, textAlign: "center", headerTextAlign: "center" },
            { name: "action", label: "Action", order: 6, isSortable: false, defaultSelected: true, textAlign: "center", headerTextAlign: "center" },
          ],
        actions: {
          viewPopup: { label: 'View Output' },
          download: { label: 'Request Download' },
          calculate: { label: 'Calculate Complexity' },
        },
      },
     };
  },
  props: ["projectParamId", "mapperParamId"],
}

</script>
